// @flow

import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { handleLogin } from 'actions/session/userAuth';
import { clearAuthMsg } from 'actions/session/authMsg';
import AuthMsg from '../authMsg/authMsg.js';
import toolHelper from 'helpers/tools.helper';
import validationHelper from 'helpers/validation.helper';
import documentHelper from 'helpers/document.helper';
import storageHelper from 'helpers/storage.helper';
import queryString from 'query-string';
import './index.css';

class Login extends Component {

  // Default state variables
  state = {
    email: '',
    password: '',
    remember: false,
    formErrors: { email: '', password: '' },
    emailValid: false,
    formValid: true,//false,
    isCapslock: false,
    plainPassword: false,
    accountUnlocked: false
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    // Clear whole localStorage to prevent
    // problems on production
    storageHelper.destroyStorage();
  }

  // Just before component will mount
  componentWillMount = () => {
    this.clearAuthMessages();

    const { translate } = this.props;
    // Document page title
    documentHelper.setTitle(translate('session.login.title_document'));
  }

  // After component & render loaded
  componentDidMount = () => {
    let parsed = queryString.parse(this.props.location.search);
    // Set unlock message
    if (parsed && parsed.account_unlocked) {
      this.setState({ accountUnlocked: true });
    }

    if (parsed.email) {
      this.setState({ email: parsed.email.split(' ').join('+'), emailValid: true });
    }
  }

  clearAuthMessages = () => {
    const { dispatch } = this.props;
    dispatch(clearAuthMsg());
  }

  // Handle input changes
  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState({ [id]: value }, () => { this.validateField(id, value) });
  }

  // Handle form submit
  handleSubmit = (e) => {
    e.preventDefault();

    const { dispatch, history } = this.props;
    const { email, password, remember } = this.state;

    // On every submit, clear out response alert messages
    dispatch(clearAuthMsg());

    // Create a login request
    dispatch(handleLogin(email, password, remember, history))
  }

  // Show or hide plain password input
  togglePlainPassword = () => {
    this.setState({ plainPassword: !this.state.plainPassword });
  }

  // Validate form
  validateField = (field, value) => {
    let emailValid = this.state.emailValid;

    switch (field) {
      case 'email':
        emailValid = validationHelper.email(value);
        break;
      default:
        break;
    }

    this.setState({ emailValid: emailValid, formValid: emailValid });
  }

  // Capslock detection
  capslockDetect = (e) => {
    let isCapslock = toolHelper.isCapslock(e);
    this.setState({ isCapslock: isCapslock });
  }

  componentWillReceiveProps(nextProps) {
    const { history } = this.props;
    if (nextProps.user.id) { history.push('/'); };
  }

  _renderFailedAttempts() {
    const { failed_attempts } = this.props.authMsg;
    const { translate } = this.props;

    if (failed_attempts === 2) {
      return (
        <div className="alert alert-danger">
          <p>{translate('session.error.one_attempt')}</p>
        </div>
      )
    } else if (failed_attempts > 2) {
      return (
        <div className="alert alert-danger">
          <p>{translate('session.error.locked')}</p>
        </div>
      )
    } else {
      return null;
    }
  }

  render() {
    const { email, password, remember, formValid, emailValid, isCapslock, plainPassword, accountUnlocked } = this.state;
    const { translate } = this.props;

    // Is Capslock on?
    let isCapslockRender;
    if (isCapslock) {
      isCapslockRender = (<CapsLockRender {...this.props} />);
    }

    // Show or hide plain password input
    let showPlainPasswordRender = (<i className={"fa fa-eye" + (plainPassword ? '' : '-slash')} onClick={this.togglePlainPassword.bind(this)} />);

    // Check if confirmation query string exists
    //  that means that user successfully confirmed his/her account
    let query_string = queryString.parse(this.props.location.search);
    let account_confirmation_success = query_string.account_confirmation_success || '';
    if (query_string && account_confirmation_success) {
      return <Redirect to='/session/login' />;
    }
    return (
      <div className="login">

        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">

              <div className="top-header">
                <div className="nick-armright"></div>
                <h2>{translate('session.login.title')}</h2>
              </div>

            </div>
          </div>
        </div>

        <div className="row main-content">
          <div className="col-xs-12 col-sm-8 col-sm-offset-2">
            <div className="row login-box">
              <form name="form_login" className="login-form pull-left" onSubmit={this.handleSubmit}>
                <div className="form-group has-float-label">
                  <input type="email" id="email" className="form-control" value={email} onChange={this.handleChange} autoFocus required />
                  <label>{translate('session.field.field_email')}</label>
                  <span className="email-icon" />
                  <span className={"validation-check " + (!emailValid ? 'uncheck' : '')}></span>
                  <AuthMsg provider='email' />
                  {accountUnlocked &&
                    <div className="alert alert-success">
                      <p dangerouslySetInnerHTML={{ __html: translate('session.unlock.success_unlock') }}></p>
                    </div>
                  }

                </div>
                <div className={"form-group has-float-label " + (isCapslock ? 'has-error' : '')}>
                  <span className="eye-icon">
                    {showPlainPasswordRender}
                  </span>
                  <input type={plainPassword ? 'text' : 'password'} id="password" value={password} onChange={this.handleChange} onKeyDown={this.capslockDetect} name="password" className="form-control" required />
                  <label>{translate('session.field.field_password')}</label>
                  <span className="password-icon" />
                </div>
                <div className="form-group">
                  {this._renderFailedAttempts()}
                  {isCapslockRender}
                </div>
                <div className="form-group">
                  <div className="checkbox-wrap">
                    <input type="checkbox" name="remember" id="remember_me" value={remember} onChange={this.handleChange} />
                    <label htmlFor="remember_me">{translate('session.common.remember_me')}</label>
                  </div>
                  <div className="forgot-password pull-right">
                    <Link to="/session/reset-password">{translate('session.common.forgot_password')}</Link>
                  </div>
                </div>

                <div className="form-group">
                  <div className="submit-wrap">
                    <div className="button-wrap">
                      <input type="submit" disabled={!formValid} name="commit" value={translate('session.common.button_login')} />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="row bottom-bar-content">
          <p className="text-center">{translate('session.common.hint.hint_checkout_faq')}</p>
        </div>

        <div className="row logins-footer">
          <h2 className="text-center">{translate('session.login.footer_title')}</h2>
          <h4 className="text-center">{translate('session.login.footer_subtitle')}</h4>

          <div className="col-xs-12 col-sm-8 col-sm-offset-2">
            <div className="row">
              <div className="col-xs-12 col-sm-4 text-center">
                <div className="fi icon-checklist"></div>
                <p>{translate('session.login.footer_feature_checklist')}</p>
              </div>
              <div className="col-xs-12 col-sm-4 text-center">
                <div className="fi icon-calculator"></div>
                <p>{translate('session.login.footer_feature_calculator')}</p>
              </div>
              <div className="col-xs-12 col-sm-4 text-center">
                <div className="fi icon-graph"></div>
                <p>{translate('session.login.footer_feature_graph')}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

class CapsLockRender extends React.Component {
  render() {
    const { translate } = this.props;

    return (
      <div className="alert alert-danger">
        <p>{translate('session.error.error_capslock')}</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  user: state.user,
  authMsg: state.authMsg
});

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/session/login/index.js